const state = {
	connectionStatus: "idle", // 'idle' | 'connecting' | 'connected' | 'error'
	errorMessage: null,
};

const mutations = {
	SET_STATUS(state, newStatus) {
		state.connectionStatus = newStatus;
		if (newStatus !== "error") {
			// Clear any old errors when we move out of error state
			state.errorMessage = null;
		}
	},
	SET_ERROR(state, errorMsg) {
		state.connectionStatus = "error";
		state.errorMessage = errorMsg;
	},
};

const actions = {
	setConnecting({ commit }) {
		commit("SET_STATUS", "connecting");
	},
	setConnected({ commit }) {
		commit("SET_STATUS", "connected");
	},
	setDisconnected({ commit }) {
		commit("SET_STATUS", "idle");
	},
	setError({ commit }, errorMsg) {
		commit("SET_ERROR", errorMsg);
	},
};

const getters = {
	connectionStatus: (state) => state.connectionStatus,
	errorMessage: (state) => state.errorMessage,
	isConnected: (state) => state.connectionStatus === "connected",
	connectionStatusName: (state) => {
		const statusNames = {
			connected: "Conectado",
			disconnected: "Desconectado",
			connecting: "Conectando...",
			error: "Error",
		};
		return statusNames[state.connectionStatus] || "Error";
	},
	connectionStatusColorClass: (state) => {
		const statusNames = {
			connected: "success",
			disconnected: "danger",
			connecting: "warning",
			error: "danger",
		};
		return statusNames[state.connectionStatus] || "danger";
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
